
import { Component, Vue } from "vue-property-decorator";
import IngenieriaItem from "./IngenieriaItem.vue";

@Component({
  components: {
    IngenieriaItem
  }
})
export default class IngenieriaEstructuras extends Vue {
  
  frame = "LINEA_2_7_ingenieria_geo.png";

  texto = `- Encauzamientos.
          <br/>
          - Estabilización de taludes.
          <br/>
          - Sellado de Vertederos.
          <br/>
          - Acondicionamiento de ríos.`;
          
}
